module.exports = __webpack_public_path__ + "img/vue.133584d7.jpg";